"use client";

import { c as _c } from "react/compiler-runtime";
import { useReportWebVitals } from "next/web-vitals";
import { usePostHog } from "posthog-js/react";
import { useCallback } from "react";
import { type MetricaWebVitals, resumirInp } from "@/lib/inp-atribuido";

/**
 * Manda para o PostHog o INP ruim COM atribuição (CHAT002-4520): qual
 * elemento, que tipo de interação, quanto foi espera, processamento e pintura,
 * e o script mais longo do quadro. Montado uma vez na raiz. A regra do que
 * entra (limiares, amostragem, o que é dado pessoal e não sai) está em
 * `resumirInp`.
 */
export function InpAtribuido() {
  const $ = _c(2);
  const posthog = usePostHog();
  let t0;
  if ($[0] !== posthog) {
    t0 = metrica => {
      const evento = resumirInp(metrica, window.location.pathname, Math.random());
      if (evento) {
        posthog?.capture("inp_atribuido", evento);
      }
    };
    $[0] = posthog;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const relatar = t0;
  useReportWebVitals(relatar);
  return null;
}